
    // IMPORTS
    import { computed, defineComponent, ref } from 'vue'
    import { useEquipmentStore } from '@/store/equipment'

    import SparepartView from '@/components/spareparts/sparepart-view.vue'
    import MyIcon from '@/components/common/my-icon.vue'
    import { buildLocalization } from '@/util';

    export default defineComponent({
        name: 'equipmentSpareParts',

        components: {
            SparepartView,
            MyIcon
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE
             ********************************************************************************************************************/
            const equipmentStore = useEquipmentStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const warningDismissed = ref(false)
            const publicData = { warningDismissed }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const modelFilter = computed(() => equipmentStore.masterData?.productModel)
            const hasEquipmentSpecificSpareparts = computed(() => equipmentStore.masterData?.noBomSync !== true)
            const computedData = { modelFilter, hasEquipmentSpecificSpareparts }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()          
            const publicMethods = { localize }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
